import React, { useState, useRef } from 'react';
import 'primereact/resources/themes/lara-light-blue/theme.css'
import '../../styles/global.css';
import '../../styles/pages/CadastroFarm.css';
import '@geoman-io/leaflet-geoman-free'
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import Cookies from 'js-cookie';
import { PiPlantFill } from "react-icons/pi";
import { MdMap } from "react-icons/md";
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import { LotesAccordionTab } from '../components/LotesAccordionTab';
import { Divider } from 'primereact/divider';
import axios, { AxiosError } from 'axios';
import { convertDate } from '../../utils/strings';
import API from '../../api/API';
import { ImovelType, STATUS } from '../../db/Orm';

// const cadastrarLote = async (lote: LoteType, mapa: L.Map) => {
//     const formData = new FormData();
//     formData.append('propriedade', String(lote.propriedade || ''));
//     formData.append('arrendatario', String(lote.arrendatario || ''));
//     formData.append('arrendamento_inicial', String(lote.arrendamento_inicio || ''));
//     formData.append('arrendamento_final', String(lote.arrendamento_final || ''));
//     formData.append('poligono', (await mapas.getShapefileBuffer(mapa)) as any, 'lote_propriedade_' + lote.propriedade + '.zip')
//     console.log('Form Data', formData)
//     try {
//         const response = await fetch(api_url + 'lotes/', requestOptions('POST', formData))
//         const data = await response.json()
//         console.log('Resposta:', data);
//     } catch (error: any) {
//         console.error('Erro na data:', error);
//     }
// }

type CadastroArrendamentoProps = {
    propriedades: Array<ImovelType>
    visible: boolean
    setVisible: Function
    edit?: boolean
}

export default function CadastroArrendamento(props: CadastroArrendamentoProps) {
    const propriedadesFiltradas = props.propriedades?.filter((p: ImovelType) => p.status === STATUS.APROVADO) || [];
    // const [plantios, setPlantios] = useState<Array<PlantioType>>([]);
    // const [poligonoPropriedade, setPoligonoPropriedade] = useState<L.GeoJSON>()
    // const [loadingPessoas, setLoadingPessoas] = useState(true)
    // const [loadingVariedades, setLoadingVariedades] = useState(true)
    // const [culturas, setCulturas] = useState<Array<any>>([])
    // const [listaCulturas, setListaCulturas] = useState<Array<any>>([])
    // const [variedades, setVariedades] = useState<Array<any>>([])
    // const [listaVariadedes, setListaVariedades] = useState<Array<any>>([])
    // const [plantio, setPlantio] = useState<PlantioType>(newPlantio());
    // const [mapa, setMapa] = useState<L.Map | null>(null)
    // const navigate = useNavigate();
    const msgs = useRef<any>(null);
    const [lotes, setLotes] = useState<Array<any>>([])

    async function cadastrar(event: React.FormEvent) {
        event.preventDefault();
        const formData = new FormData()
        let erro: boolean = false
        let erroMsg: string = ''
        setWaiting(true)
        if (arrendatario) {
            await axios.get(API.url + 'users/?username=' + arrendatario.replaceAll(/\D/g, ''), { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
                .then((res: any) => {
                    formData.append('arrendatario_id', res.data[0].id)
                })
                .catch((error: AxiosError) => {
                    console.log(error)
                    erro = true
                    erroMsg = 'Erro ao consultar CPF/CNPJ do arrendatário'
                })
        }
        if (erro) {
            toast.current?.show({ severity: 'error', summary: 'Cadastro de Arrendamento', detail: erroMsg })
            setWaiting(false)
            return
        }
        dataInicioArrendamento && formData.append('arrendamento_inicio', convertDate(dataInicioArrendamento))
        contrato && formData.append('contrato', contrato)
        await axios.post(API.url + 'arrendamentos/', formData, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } }).then(async (response: any) => {
            console.log('Cadastro de arrendamento', response)
            if (response.status === 200 || response.status === 201) {
                const arrendamento = response.data
                try {
                    for (let lote of lotes) {
                        if (erro) break
                        
                        const formData2 = new FormData()
                        formData2.append('lote_id', lote.id)
                        formData2.append('arrendamento', arrendamento.id)
                        await axios.post(API.url + 'arrendamentolote/', formData2, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
                            .then(() => {
                                console.log('Arrendamento', arrendamento, 'Lote', lote, 'cadastrado com sucesso')
                            })
                            .catch((error: AxiosError) => {
                                console.log(error)
                                erro = true
                                erroMsg = 'Não foi possível fazer o cadastro de arrendamento'
                                if (error.response && error.response.data) {
                                    console.error('Dados do erro:', error.response.data);
                                }
                            })
                    }
                    setWaiting(false)
                    if (erro) {
                        toast.current?.show({ severity: 'error', summary: 'Cadastro de Arrendamento', detail: erroMsg })
                    } else {
                        toast.current?.show({ severity: 'success', summary: 'Cadastro de Arrendamento', detail: 'Cadastro bem sucedido' })
                    }
                } catch (error: any) {
                    console.log(error)
                }
                toast.current?.show({ severity: 'success', summary: 'Cadastro de Arrendamento', detail: 'Cadastro bem sucedido' })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Cadastro de Arrendamento', detail: 'Erro ao cadastrar arrendamento' })
            }
        }).catch((error: AxiosError) => {
            console.log(error)
            erro = true
            erroMsg = 'Erro ao cadastrar arrendamento'
            toast.current?.show({ severity: 'error', summary: 'Cadastro de Arrendamento', detail: erroMsg })
            if (error.response && error.response.data) {
                console.error('Dados do erro:', error.response.data);
            }
            }).catch((error: any) => {
                console.error('Erro ao cadastrar arrendamento:', error);
                erro = true
                erroMsg = 'Erro ao cadastrar arrendamento'
                toast.current?.show({ severity: 'error', summary: 'Cadastro de Arrendamento', detail: erroMsg })
            })
        setWaiting(false)
        if (!erro) {
            props.setVisible(false)
            setLotes([])
            setArrendatario('')
            setDataInicioArrendamento('')
            setContrato('')
        }
    }

    const cadastroValido: Function = () => {
        const matchCPF = (/^\d{3}.\d{3}.\d{3}-\d{2}$/).test(arrendatario)
        const matchCNPJ = (/^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/).test(arrendatario)
        return (!lotes.length) || !(matchCPF || matchCNPJ) || !dataInicioArrendamento || !contrato
    }

    // const accept = () => {
    //     setPlantio(newPlantio())
    //     mapas.clearMap(mapa)
    // }

    // const reject = () => {
    //     navigate('/home')
    // }

    //const [errorNome, setErrorNome] = useState('')
    const toast = useRef<Toast | null>(null);


    const headerElement = (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <PiPlantFill />
            <span style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>Cadastro de Arrendamento</span>
        </div>
    )

    const [arrendatario, setArrendatario] = useState<string>('')
    const [dataInicioArrendamento, setDataInicioArrendamento] = useState<any>('')
    const [contrato, setContrato] = useState<any>('')
    const [waiting, setWaiting] = useState<boolean>(false)
    const [countLotes, setCountLotes] = useState<number>(0)
    return (
        <Dialog visible={props.visible} header={headerElement} maximizable style={{ width: '1000px' }} onHide={() => { props.setVisible(false) }} resizable position={'center'} modal>
            <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 280 }} />
            <ConfirmDialog />
            <Toast ref={toast} position="bottom-right" />
            <Divider align='left'>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <MdMap style={{ marginRight: 5 }} />
                    <b>Lotes</b>
                    {/* {lotes.length > 0 && <Badge value={lotes.length} />} */}
                    {countLotes > 0 && <Badge style={{ marginLeft: 5 }} value={countLotes} />}
                </div>
            </Divider>
            <LotesAccordionTab
                lotes={lotes}
                setCount={(value: number) => setCountLotes(value)}
                arrendatario={arrendatario}
                setArrendatario={(value: any) => setArrendatario(value)}
                dataInicioArrendamento={dataInicioArrendamento}
                setDataInicioArrendamento={(value: any) => setDataInicioArrendamento(value)}
                setContrato={setContrato}
                propriedades={propriedadesFiltradas}
            />
            <div style={{ height: 5 }} />
            <Button label={waiting ? '' : 'CADASTRAR'} icon={waiting ? '' : 'pi pi-send'}
                iconPos='right' severity="success" rounded onClick={cadastrar}
                disabled={cadastroValido() || waiting} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
        </Dialog >

    );
}